module.exports = __webpack_public_path__ + "static/img/6.3f961f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/6.png
// module id = 5r+Z
// module chunks = 1 3